// O evento selecionado sobrevive ao reload.
//
// Antes ele vivia só na memória do Vuex: recarregar qualquer tela de evento
// (Robôs, Chaves, Lutas, Grupos, Pódio, Inscrições) zerava a seleção, e o getter
// getCurrentEvent caía no fallback "evento em andamento" — na prática o usuário
// era jogado para outro evento sem pedir.
//
// Guardado no localStorage, como já é feito com o usuário logado.
export const CHAVE_EVENTO = 'currentEventId'

const eventoSalvo = () => {
  try {
    const bruto = localStorage.getItem(CHAVE_EVENTO)
    const id = parseInt(bruto, 10)
    return Number.isInteger(id) && id > 0 ? id : null
  } catch (e) {
    // localStorage indisponível (janela privada, cookies bloqueados)
    return null
  }
}

const state = {
  events: [],
  currentEventId: eventoSalvo(),
  eventSummary: []
}

export default state
